.content {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.modalpdf {
  height: 80vh;
}

.descriptionRessource {
  text-overflow: ellipsis;
  display: block;
  width: 100%;
  overflow: hidden;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.linkLibelle {
  background: #acdaff;
  border-radius: 11px;
  padding: 2px 5px;
  font-size: 0.8rem;
  font-weight: bold;
  margin-right: 10px;
}

.card {
  display: flex;
  flex: 0 0 50%;
}

.cardLink {
  cursor: pointer;
}

.link {
  display: flex;
  align-items: center;
  text-decoration: none;
}

.imageRessource {
  border-radius: 50px;
  width: 150px;
  height: 150px;
  object-fit: cover;
}
